// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup-playlist__container{top:50%;right:50%;bottom:auto;transform:translate(50%,-50%);width:360px;margin-top:-70px;margin-left:-180px}", ""]);
// Exports
module.exports = exports;
